/**
 * A stub error service provider that does nothing.
 */
export default class StubErrorServiceProvider {
  init() {}
  error(_error) {}
}